















import { Component, Vue, Prop } from 'vue-property-decorator';
import { qrcode, svg2url } from 'pure-svg-code';
import moment from 'moment';

@Component
export default class CIndex extends Vue {
  @Prop() pid!: string;
  @Prop() pTitle!: string;
  @Prop() oname!: string;
  @Prop() donorname!: string;

  get timeStr() {
    const currentDate = moment();
    const currentYear = currentDate.format('YYYY');;
    const currentMonth = currentDate.format('MM'); // 注意：moment.js 中的月份是从 0 开始的，因此需要加 1
    const currentDay = currentDate.format('DD');;
    return `${currentYear}年${currentMonth}月${currentDay}日`;
  }

  get qrcodeImg() {
    return this.buildQrcode(`https://apps.wechatpay.com.hk/charity/index.shtml?pid=${this.pid}`)
  }

  get info() {
    return `感謝你於${this.timeStr}參加騰訊基金會99公益日，為${this.pTitle}項目進行捐贈，騰訊基金會將會捐出與你等額的善款至該項目。`
  }

  /**
  * 生成二维码
  */
  buildQrcode(str: string) {
    let code = '';
    const qrSvgStr = qrcode({
      content: str,
      padding: 0,
      color: '#000000',
      background: '#ffffff',
      ecl: 'M',
    });
    code = svg2url(qrSvgStr);

    return code;
  }
}
